/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentAcceptance } from './DocumentAcceptance';
import {
    DocumentAcceptanceFromJSON,
    DocumentAcceptanceFromJSONTyped,
    DocumentAcceptanceToJSON,
    DocumentAcceptanceToJSONTyped,
} from './DocumentAcceptance';

/**
 * 
 * @export
 * @interface CreateDocumentAcceptanceResponse
 */
export interface CreateDocumentAcceptanceResponse {
    /**
     * 
     * @type {DocumentAcceptance}
     * @memberof CreateDocumentAcceptanceResponse
     */
    data: DocumentAcceptance;
}

/**
 * Check if a given object implements the CreateDocumentAcceptanceResponse interface.
 */
export function instanceOfCreateDocumentAcceptanceResponse(value: object): value is CreateDocumentAcceptanceResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateDocumentAcceptanceResponseFromJSON(json: any): CreateDocumentAcceptanceResponse {
    return CreateDocumentAcceptanceResponseFromJSONTyped(json, false);
}

export function CreateDocumentAcceptanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDocumentAcceptanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': DocumentAcceptanceFromJSON(json['data']),
    };
}

  export function CreateDocumentAcceptanceResponseToJSON(json: any): CreateDocumentAcceptanceResponse {
      return CreateDocumentAcceptanceResponseToJSONTyped(json, false);
  }

  export function CreateDocumentAcceptanceResponseToJSONTyped(value?: CreateDocumentAcceptanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DocumentAcceptanceToJSON(value['data']),
    };
}

